module.exports = __webpack_public_path__ + "media/images/dividend/il-coupontheme-labor-right-812a9e8ae5978904b3d0e00a7e9efa82.svg";